/* Wav Monopoly — hero background parallax (cards drift on mouse move) */
(function () {
  if (window.__wmHeroParallax) return;
  window.__wmHeroParallax = true;

  var mm = window.matchMedia;
  var reduce = mm && mm('(prefers-reduced-motion: reduce)').matches;
  var finePointer = mm && mm('(hover: hover) and (pointer: fine)').matches;

  function init(hero) {
    if (hero.__wmPx) return;
    hero.__wmPx = true;

    var nodes = hero.querySelectorAll('[data-depth]');
    if (!nodes.length || reduce || !finePointer) return;

    // Cache each card + its (static) depth once.
    var items = [];
    for (var i = 0; i < nodes.length; i++) {
      items.push({ el: nodes[i], d: parseFloat(nodes[i].getAttribute('data-depth')) || 0 });
    }
    hero.classList.add('wm-px-on');

    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, rect = null;

    function readRect() { rect = hero.getBoundingClientRect(); }

    function tick() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      for (var i = 0; i < items.length; i++) {
        var d = items[i].d;
        items[i].el.style.transform =
          'translate3d(' + (-cx * d).toFixed(2) + 'px,' + (-cy * d * 0.6).toFixed(2) + 'px,0) rotate(var(--rot,0deg))';
      }
      if (Math.abs(tx - cx) > 0.0008 || Math.abs(ty - cy) > 0.0008) raf = requestAnimationFrame(tick);
      else raf = null;
    }
    function nudge() { if (!raf) raf = requestAnimationFrame(tick); }

    hero.addEventListener('mouseenter', readRect);
    hero.addEventListener('mousemove', function (e) {
      if (!rect) readRect();
      tx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      ty = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      nudge();
    });
    hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; nudge(); });
    window.addEventListener('resize', function () { rect = null; }, { passive: true });
    window.addEventListener('scroll', function () { rect = null; }, { passive: true });
  }

  function initAll() {
    var heroes = document.querySelectorAll('[data-wm-parallax]');
    for (var i = 0; i < heroes.length; i++) init(heroes[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
